import s from './TryonBtn.module.scss'
import ar from '../../../assets/ar_btn.svg'
import { useAppStore } from '../../../shared/store/store'

type ParamKey = string
type ParamValue = string | null | number | boolean | object

type Param = {
  key: ParamKey
  value: ParamValue
}

interface TryonBtnProps {
  jewelryId: string
}

const convertParamsToUrl = (params: Param[]) => {
  const urlParams = new URLSearchParams()
  params.forEach((param) => {
    urlParams.append(param.key, JSON.stringify(param.value))
  })
  return urlParams
}

export const TryonBtn = ({ jewelryId }: TryonBtnProps) => {
  const currentDiamondCut = useAppStore((state) => state.currentDiamondCut)
  const currentSize = useAppStore((state) => state.currentSize)
  const currentMaterialColor = useAppStore((state) => state.currentMaterialColor)
  const currentLetter = useAppStore((state) => state.currentLetter)

  const handleTryon = () => {
    const params: Param[] = [
      { key: 'diamondCut', value: currentDiamondCut ? [currentDiamondCut] : null },
      { key: 'materialColors', value: currentMaterialColor ? [currentMaterialColor] : null },
      { key: 'letter', value: currentLetter ? currentLetter : null },
      { key: 'stoneSizes', value: currentSize ? [currentSize] : null },
    ]

    const baseUrl = `https://trillion.jewelry/widget.html?id=${jewelryId}`
    const urlParams = convertParamsToUrl(params)
    const fullUrl = `${baseUrl}&${urlParams.toString()}`
    window.open(fullUrl, '_blank')
  }

  return (
    <div className={s.btn} onClick={handleTryon}>
      <img src={ar} alt="AR Icon" />
      Try-ON
    </div>
  )
}
